import React , { useState , useEffect } from 'react'

import { useNavigate , useLocation } from "react-router-dom";

import { ApiCallGet } from '../ApiCall/ApiCall';

export default function Login( {clear}) {

    const [correo, setCorreo] = useState("");   
    const [password, setPassword] = useState("");


    const navigate = useNavigate();

    const location = useLocation();

    useEffect(() => {
        if ( location.state === null ){
            //clear(); (( Para la doble carga del login))
        }
    } , [])

    

    function onSubmit(e) {
        e.preventDefault();
        console.log("submit");

        if ( correo === "" || password === "" ){ // Validamos que esten completos los datos
            alert("Debe llenar todos los campos")
            return;
        }


        console.log( 'login/?email=' + correo + "&password=" + password)
        


        ApiCallGet('login/?email=' + correo + "&password=" + password)
        .then( (response) => {
            console.log( response )

            if ( response.length === 0 )
            {   navigate("/") // aqui habia login
                alert("Usuario o contraseña incorrectos")

                return ;
                
            }
            clear() ;

            
            setTimeout(navigate( "/header" , { state : { nombre : response[0].nombre , 
                email : response[0].email , password : response[0].password } }) , 500 )
        } )
        .catch( (error) => {
            console.log( error )

            alert( "Error en el proceso de login (reportar a sistemas)")
        })

        //navigate( "/header" , { state : { email : correo , password : password } })



    }


  return (
    <div className='d-flex flex-column  justify-content-center box-1 backemployer-2 centersearch' >

    < div className='d-flex flex-column justify-content-center box-1 backemployer-2 mb-5 form-2 w-75'  id="page1" style={{margin : 'auto'}}>

    <h1>Digital Sms</h1>

    <h3>Login</h3>

    <form onSubmit={onSubmit}>

        <div className='row'>

            <div className='col-4'>
                <label className="form-label m-0" htmlFor="correo">Correo</label>
                <input type="email" className="form-control" id="correo" onChange={(e) => setCorreo(e.target.value)} />
            </div>

            <div className='col-4'>
                <label className="form-label m-0" htmlFor="password">Password</label>
                <input type="password" className="form-control" id="password" onChange={(e) => setPassword(e.target.value)}/>
            </div>

        </div>

        <div className='col'>

            <button type="submit"  className="btn btn-primary mt-3 button-3"  >Aceptar</button>

        </div>


    </form>

    </div>
    </div>
  
  )
}
